/* HS 5-sep-2026 - kleurstalen op de productkaart (collectiegrid).
   Aanwijzen/focussen van een staal wisselt foto, prijs en link van de kaart; klikken opent de
   productpagina in die kleur. Zolang de muis op een staal staat, toont de kaart de HOOFDFOTO van
   die kleur (de kaart staat immers in :hover en zou anders het sfeerbeeld tonen - verzoek Guus,
   5 sep 2026); verlaat de muis de stalenrij, dan komt het sfeerbeeld van de gekozen kleur terug.
   HS 16-sep-2026 (verzoek Guus): op mobiel twee pijltjes links en rechts op de kaartfoto en een
   horizontale veegbeweging over de foto; beide bladeren naar de vorige of volgende kleur met
   dezelfde wissel (foto, prijs, link, actieve staal). De pijltjes staan in een eigen houder op
   .card-wrapper, NIET in .card__inner: de kaartbrede link van het thema (.card__heading a::after,
   z-index 1) ligt over het hele kaartvlak en .card__inner is een eigen stapelcontext (transform op
   .gradient), dus pijltjes daarbinnen zijn voor een tik onbereikbaar. Om dezelfde reden luistert de
   veegherkenning op de hele kaart en reageert ze alleen als de aanraking in het fotovlak begint.
   v3 (zelfde avond, feedback Guus): de kleur wisselt al TIJDENS de veeg zodra de drempel gehaald is
   (niet pas bij loslaten), de buurfoto's worden bij de eerste aanraking alvast opgehaald zodat de
   wissel direct zichtbaar is, een korte opacity-tik maakt de wissel zichtbaar, de tikblokkade na een
   veeg is 150 ms (was 400) zodat een tik meteen na een veeg gewoon het product opent, en de pijltjes
   hebben een tikvlak van 4,4 rem (css).
   v4 (feedback Guus: donker vlak tijdens de veeg): de wissel gaat nu via een overvloeiing. De nieuwe
   foto wordt als extra laag over de oude gelegd, pas zichtbaar gemaakt als hij gedecodeerd is, en vloeit
   in 220 ms over; daarna neemt de hoofdfoto hem over en gaat de laag weg. Geen opacity-tik meer en geen
   dimmen bij aanraken.
   v5 (feedback Guus: na een veeg twee keer tikken nodig om het product te openen): een schone tik op de
   foto (geen beweging, korter dan 500 ms, niet op een pijltje of staal) opent het product direct vanuit
   touchend via een klik op de kaartlink, en de nagebootste browserklik wordt onderdrukt. Zo hangt het
   openen niet meer af van de klik-synthese van de mobiele browser na een veeg. Zie snippets/hs-kaart-stalen.liquid. */
(function () {
  'use strict';

  var PIJL_SVG = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">'
    + '<path d="M10.5 2.5 5 8l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function meld(methode) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'stalen_wissel', stalen_methode: methode });
    } catch (e) { /* meten mag nooit de wissel breken */ }
  }

  function initKaart(rij) {
    if (rij.dataset.hsInit) return;
    rij.dataset.hsInit = '1';
    var kaart = rij.closest('.card-wrapper');
    if (!kaart) return;
    var beelden = kaart.querySelectorAll('.card__inner .media img');
    var hoofd = beelden[0] || null;
    var hover = beelden[1] || null;
    var links = kaart.querySelectorAll('a.full-unstyled-link');
    var knoppen = rij.querySelectorAll('.hs-staal');
    var gekozen = rij.querySelector('.hs-staal[aria-pressed="true"]') || knoppen[0];

    function zetHover(knop, hoofdfoto) {
      if (!hover) return;
      if (hoofdfoto && knop.dataset.src) {
        hover.srcset = knop.dataset.srcset || '';
        hover.src = knop.dataset.src;
        hover.hidden = false;
      } else if (knop.dataset.hoverSrc) {
        hover.srcset = knop.dataset.hoverSrcset || '';
        hover.src = knop.dataset.hoverSrc;
        hover.hidden = false;
      } else {
        hover.hidden = true;
      }
    }

    function zetBeeld(knop) {
      if (hoofd && knop.dataset.src) {
        hoofd.srcset = knop.dataset.srcset || '';
        hoofd.src = knop.dataset.src;
        if (knop.dataset.alt) hoofd.alt = knop.dataset.alt;
      }
    }

    function zetRest(knop) {
      var sjabloon = rij.querySelector('template[data-hs-prijs="' + knop.dataset.id + '"]');
      var prijs = kaart.querySelector('.card > .card__content .price');
      if (sjabloon && prijs && sjabloon.content && sjabloon.content.firstElementChild) {
        prijs.replaceWith(sjabloon.content.firstElementChild.cloneNode(true));
      }
      for (var i = 0; i < links.length; i++) links[i].href = knop.dataset.url;
      for (var j = 0; j < knoppen.length; j++) knoppen[j].setAttribute('aria-pressed', knoppen[j] === knop ? 'true' : 'false');
    }

    function toon(knop, viaMuis) {
      gekozen = knop;
      zetBeeld(knop);
      zetHover(knop, viaMuis);
      zetRest(knop);
    }

    // v4: wissel met overvloeiing (mobiel). De nieuwe foto komt als laag over de oude, wordt pas
    // zichtbaar als hij gedecodeerd is en vloeit dan in 220 ms over; daarna neemt de hoofdfoto hem
    // over (uit de cache, dus zonder leeg vlak) en gaat de laag weg. Een lopende overgang wordt
    // afgebroken als er alweer gewisseld wordt.
    var overgang = null;
    function toonSoepel(knop) {
      gekozen = knop;
      zetHover(knop, false);
      zetRest(knop);
      if (!hoofd || !knop.dataset.src || !hoofd.parentNode) { zetBeeld(knop); return; }
      if (overgang && overgang.parentNode) overgang.parentNode.removeChild(overgang);
      var laag = document.createElement('img');
      laag.className = 'hs-overgang';
      laag.alt = '';
      laag.setAttribute('aria-hidden', 'true');
      laag.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center center;opacity:0;transition:opacity 0.22s ease;pointer-events:none;';
      if (hoofd.sizes) laag.sizes = hoofd.sizes;
      if (knop.dataset.srcset) laag.srcset = knop.dataset.srcset;
      laag.src = knop.dataset.src;
      hoofd.parentNode.appendChild(laag);
      overgang = laag;
      var getoond = false;
      function toonLaag() {
        if (getoond) return;
        getoond = true;
        if (overgang !== laag) return; // inmiddels afgebroken door een nieuwe wissel
        laag.style.opacity = '1';
        window.setTimeout(function () {
          if (overgang !== laag) return;
          zetBeeld(knop); // zelfde bestand, al gedecodeerd: geen leeg vlak
          window.setTimeout(function () {
            if (laag.parentNode) laag.parentNode.removeChild(laag);
            if (overgang === laag) overgang = null;
          }, 80);
        }, 240);
      }
      function naLaden() {
        if (laag.decode) laag.decode().then(toonLaag, toonLaag); else toonLaag();
      }
      if (laag.complete && laag.naturalWidth > 0) naLaden(); else laag.addEventListener('load', naLaden);
      laag.addEventListener('error', toonLaag);
      window.setTimeout(toonLaag, 1500); // vangnet: nooit blijven hangen
    }

    for (var k = 0; k < knoppen.length; k++) {
      (function (knop) {
        knop.addEventListener('mouseenter', function () { toon(knop, true); });
        knop.addEventListener('focus', function () { toon(knop, false); });
        knop.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toon(knop, true);
          window.location.href = knop.dataset.url;
        });
      })(knoppen[k]);
    }
    // muis verlaat de stalenrij: sfeerbeeld van de gekozen kleur terug als hoverfoto
    rij.addEventListener('mouseleave', function () { if (gekozen) zetHover(gekozen, false); });

    /* --- 16-sep-2026: bladeren door de kleuren met pijltjes en een veegbeweging (mobiel) --- */
    if (knoppen.length < 2) return;
    var binnen = kaart.querySelector('.card__inner');
    if (!binnen || kaart.querySelector('.hs-stalen-pijlen')) return;
    kaart.classList.add('hs-heeft-stalen');

    function index(knop) {
      for (var i = 0; i < knoppen.length; i++) if (knoppen[i] === knop) return i;
      return -1;
    }

    // Foto van een kleur alvast ophalen, met dezelfde srcset en sizes als de kaartfoto, zodat de
    // browser precies het bestand kiest dat de wissel straks nodig heeft (cache-treffer, geen wachttijd).
    var geladen = {};
    function laadVoor(knop) {
      if (!knop || !knop.dataset.src || geladen[knop.dataset.id]) return;
      geladen[knop.dataset.id] = true;
      var im = new Image();
      if (hoofd && hoofd.sizes) im.sizes = hoofd.sizes;
      if (knop.dataset.srcset) im.srcset = knop.dataset.srcset;
      im.src = knop.dataset.src;
    }
    function laadBuren() {
      var i = index(gekozen), n = knoppen.length;
      laadVoor(knoppen[(i + 1) % n]);
      laadVoor(knoppen[(i - 1 + n) % n]);
    }

    // volgende (+1) of vorige (-1) kleur, rondlopend; zonder muis-gedrag (viaMuis = false),
    // zodat de hoverfoto het sfeerbeeld van de nieuwe kleur blijft; overvloeiing via toonSoepel.
    function stap(richting, methode) {
      var volgende = (index(gekozen) + richting + knoppen.length) % knoppen.length;
      toonSoepel(knoppen[volgende]);
      meld(methode);
      laadBuren();
    }

    function maakPijl(richting) {
      var pijl = document.createElement('button');
      pijl.type = 'button';
      pijl.className = 'hs-stalen-pijl ' + (richting < 0 ? 'hs-stalen-pijl--links' : 'hs-stalen-pijl--rechts');
      pijl.setAttribute('aria-label', richting < 0 ? 'Vorige kleur' : 'Volgende kleur');
      pijl.innerHTML = PIJL_SVG;
      pijl.addEventListener('click', function (e) {
        // niet doorlaten naar de kaartbrede link (a::after over de hele kaart)
        e.preventDefault();
        e.stopPropagation();
        stap(richting, 'pijl');
      });
      return pijl;
    }

    // Houder met de hoogte van het fotovlak, absoluut bovenin .card-wrapper en met z-index 2 boven de
    // kaartbrede link (z-index 1); de houder zelf laat aanrakingen door (pointer-events: none), alleen
    // de pijltjes vangen ze.
    var houder = document.createElement('div');
    houder.className = 'hs-stalen-pijlen';
    var ratio = (binnen.style.getPropertyValue('--ratio-percent') || getComputedStyle(binnen).getPropertyValue('--ratio-percent') || '').trim();
    if (ratio) houder.style.setProperty('--ratio-percent', ratio);
    houder.appendChild(maakPijl(-1));
    houder.appendChild(maakPijl(1));
    kaart.appendChild(houder);
    // Hoogte van de houder = gemeten hoogte van het fotovlak (de padding-bottom in de css is de terugval).
    // Zo staan de pijltjes altijd precies op het midden van de foto, ook na draaien van het scherm.
    function pasHoogte() {
      var hoogte = binnen.getBoundingClientRect().height;
      if (hoogte > 0) { houder.style.height = Math.round(hoogte) + 'px'; houder.style.paddingBottom = '0'; }
    }
    pasHoogte();
    if ('ResizeObserver' in window) new ResizeObserver(pasHoogte).observe(binnen);
    else window.addEventListener('resize', pasHoogte);

    // Veegbeweging over de foto. De aanraking begint bij de kaartbrede link (die ligt over de foto),
    // dus luisteren op de hele kaart en alleen reageren als het startpunt in het fotovlak ligt.
    // De wissel gebeurt al TIJDENS de beweging zodra de drempel gehaald is (30 px horizontaal en
    // duidelijk meer dan verticaal), een wissel per veeg. Passief, zonder preventDefault: verticaal
    // scrollen blijft bij de browser (css: touch-action pan-y op de kaart).
    function inFoto(t) {
      var r = binnen.getBoundingClientRect();
      return t.clientX >= r.left && t.clientX <= r.right && t.clientY >= r.top && t.clientY <= r.bottom;
    }
    var startX = null, startY = null, startT = 0, startDoel = null, bewogen = 0, geschakeld = false, laatsteVeeg = 0;
    kaart.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1 || !inFoto(e.touches[0])) { startX = null; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
      startDoel = e.target;
      bewogen = 0;
      geschakeld = false;
      laadBuren();
    }, { passive: true });
    kaart.addEventListener('touchmove', function (e) {
      if (startX === null || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      bewogen = Math.max(bewogen, Math.abs(dx), Math.abs(dy));
      if (geschakeld) return;
      if (Math.abs(dx) >= 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        geschakeld = true;
        laatsteVeeg = Date.now();
        stap(dx < 0 ? 1 : -1, 'veeg');
      }
    }, { passive: true });
    // v5: niet passief. Een schone tik op de foto (geen beweging, korter dan 500 ms, niet op een pijltje
    // of staal, niet binnen 150 ms na een veeg) opent het product meteen via een klik op de kaartlink;
    // de nagebootste browserklik wordt onderdrukt. Lang indrukken blijft bij de browser (contextmenu).
    kaart.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var duur = Date.now() - startT;
      var t = e.changedTouches && e.changedTouches[0];
      if (t) bewogen = Math.max(bewogen, Math.abs(t.clientX - startX), Math.abs(t.clientY - startY));
      var opKnop = !!(startDoel && startDoel.closest && startDoel.closest('.hs-stalen-pijl, .hs-staal'));
      var tik = !geschakeld && bewogen < 10 && duur < 500 && !opKnop && (Date.now() - laatsteVeeg) >= 150;
      if (geschakeld) laatsteVeeg = Date.now();
      startX = null;
      geschakeld = false;
      if (tik && links[0] && links[0].href) {
        e.preventDefault();
        links[0].click(); // echte klik op de kaartlink: de kaartklikmeting ziet hem en de browser navigeert
      }
    }, { passive: false });
    kaart.addEventListener('touchcancel', function () { startX = null; geschakeld = false; }, { passive: true });
    // De klik die een browser soms direct na een veeg afvuurt (binnen 150 ms) mag de kaart niet
    // openen; een bewuste tik daarna gaat gewoon door naar het product.
    kaart.addEventListener('click', function (ev) {
      if (laatsteVeeg && Date.now() - laatsteVeeg < 150) { ev.preventDefault(); ev.stopPropagation(); }
    }, true);
  }

  function init(wortel) {
    var rijen = (wortel || document).querySelectorAll('[data-hs-stalen]');
    for (var i = 0; i < rijen.length; i++) initKaart(rijen[i]);
  }

  init(document);

  // facets.js vervangt het raster bij filteren/sorteren: nieuwe kaarten opnieuw koppelen.
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () { init(container); }).observe(container, { childList: true, subtree: true });
  }
})();
